import React, { useState } from "react"
import "./style.scss"
import {
    Text
} from "@sitecore-jss/sitecore-jss-react"
import { useTranslation } from "react-i18next";


const SearchFilterDropdown = ({ queryText, pageID, type, currentPage, itemPerPage, search, isPressRelease
}) => {const { t } = useTranslation();
  const [searchFilter,setsearchFilter] = useState("");

  const handleChange = (event) => {
    setsearchFilter(event.target.value);

    if (queryText && queryText != "") {
        let redirectUrl = "";
        if (type && type != "" && pageID && pageID != "") {
          redirectUrl = `${search}?q=${queryText}&page=1&take=${itemPerPage}&type=${type}&pageID=${pageID}`;
        } else {
          redirectUrl = `${search}?q=${queryText}&page=1&take=${itemPerPage}`; 
        }
        if (event.target.value == "true") {
            redirectUrl = redirectUrl.concat("&ispr=true");
        } else if (event.target.value == "false") {
            redirectUrl = redirectUrl.concat("&ispr=false")
        }

        if (typeof window !== "undefined") {
          window.location.href = redirectUrl;
        }
      }
  }

    return (
        <>
            {
                <>
                    <Text
                        field={{ value: `${t("CnhindustrialcomFilterby")}` }}
                        tag='span'
                        className='filter_text'
                    />
                    <div className='filter_selection'>
                        <select name="searchfilter" className='searchSelect' value={isPressRelease} onChange={handleChange}>
                            <option value="">{t("CnhindustrialcomAllPages")}</option>
                            <option value="true">{t("CnhindustrialcomPressReleases")}</option>
                            <option value="false">{t("CnhindustrialcomPages")}</option>
                        </select>
                    </div>
                </>
            }
        </>
    )
}

export default SearchFilterDropdown
